import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="nested-fields"
export default class extends Controller {
  static targets = ["container", "template"];

  static values = {
    wrapperClass: String,
    newRecordPlaceholder: { type: String, default: "NEW_RECORD" },
  };

  add(event) {
    event.preventDefault();
    const content = this.templateTarget.innerHTML.replace(
      new RegExp(this.newRecordPlaceholderValue, "g"),
      new Date().getTime()
    );
    this.containerTarget.insertAdjacentHTML("beforeend", content);
  }

  remove(event) {
    event.preventDefault();
    const wrapper = event.target.closest(`.${this.wrapperClassValue}`);
    if (!wrapper) return;

    const destroyField = wrapper.querySelector("input[name*='_destroy']");
    if (destroyField) {
      destroyField.value = 1;
      wrapper.style.display = "none";
    } else {
      wrapper.remove();
    }
    this.element.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
